import {
    cloneDeep,
} from 'lodash';

import {
    createImage,
} from './elements';

import {
    initState,
    getRelativeBounds,
    initContentState,
} from './engineState';

import {
    defaultLimits,
} from './engineCore';

export async function prepareStateForImage (imageSource, shape) {
    const { image } = await createImage(imageSource);
    initState(getRelativeBounds(window.editorUI.workspace), image, shape);
    initContentState(image);
    window.currentEditorState = cloneDeep(window.editorState);
}

export async function updateEditorStateLimits (shape) {
    if (shape === 'round') {
        window.editorLimits.maxCanvasWidth = defaultLimits.maxRoundSize;
        window.editorLimits.maxCanvasHeight = defaultLimits.maxRoundSize;
    } else {
        window.editorLimits.maxCanvasWidth = defaultLimits.maxCanvasWidth;
        window.editorLimits.maxCanvasHeight = defaultLimits.maxCanvasHeight;
    }
    window.editorUI.shape = shape;
}
